(function () {
  const root = document.querySelector('[data-qc-love]');
  if (!root) return;

  const product = JSON.parse(root.querySelector('[data-qc-product-json]').textContent);
  let catalogProducts = [];
  try {
    const catalogEl = root.querySelector('[data-qc-catalog-json]');
    catalogProducts = JSON.parse((catalogEl && catalogEl.textContent) || '[]');
  } catch (e) {
    catalogProducts = [];
  }
  const useCatalogPacks = catalogProducts.length > 0;
  const moneyFormat = root.dataset.moneyFormat || '{{amount}} DH';
  const checkoutUrl = root.dataset.checkoutUrl || '/checkout';
  const cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
  const cartClearUrl = root.dataset.cartClearUrl || '/cart/clear.js';
  const cartUpdateUrl = root.dataset.cartUpdateUrl || '/cart/update.js';

  const packs = Array.from(root.querySelectorAll('[data-qc-pack]'));
  const priceEls = root.querySelectorAll('[data-qc-price]');
  const compareEls = root.querySelectorAll('[data-qc-compare]');
  const mainImage = root.querySelector('[data-qc-main-image]');
  const thumbs = Array.from(root.querySelectorAll('[data-qc-thumb]'));
  const colorImagesEl = root.querySelector('[data-qc-color-images]');
  let colorImages = {};
  try {
    colorImages = JSON.parse((colorImagesEl && colorImagesEl.dataset.qcColorImages) || '{}');
  } catch (e) {
    colorImages = {};
  }
  const errorEl = root.querySelector('[data-qc-error]');
  const form = root.querySelector('[data-qc-form]');
  const submitBtn = root.querySelector('[data-qc-submit]');
  let orderSubmitting = false;
  const hoursEl = root.querySelector('[data-qc-hours]');
  const minutesEl = root.querySelector('[data-qc-minutes]');
  const secondsEl = root.querySelector('[data-qc-seconds]');

  const colorMap = {
    black: '#111111',
    noir: '#111111',
    gray: '#8a8a8a',
    grey: '#8a8a8a',
    gris: '#8a8a8a',
    'army green': '#4b5d23',
    army: '#4b5d23',
    vert: '#4b5d23',
    burgandy: '#6b2d3c',
    burgundy: '#6b2d3c',
    bordeaux: '#6b2d3c',
    'navy blue': '#1b2a4a',
    navy: '#1b2a4a',
    bleu: '#1b2a4a',
    brown: '#5c4033',
    marron: '#5c4033',
    white: '#f4f4f4',
    blanc: '#f4f4f4',
  };

  function formatMoney(amount) {
    const value = (Number(amount) / 100).toFixed(0);
    return moneyFormat.replace('AMOUNT', value).replace('{{amount}}', value).replace('{{amount_no_decimals}}', value);
  }

  function optionNames() {
    return (product.options || []).map(function (option) {
      return typeof option === 'string' ? option : option.name;
    });
  }

  function sizeKey() {
    const names = optionNames();
    const index = names.findIndex(function (name) {
      return /size|taille/i.test(name || '');
    });
    return index === -1 ? 0 : index;
  }

  function colorKey() {
    const names = optionNames();
    const index = names.findIndex(function (name) {
      return /color|colour|couleur/i.test(name || '');
    });
    return index === -1 ? 1 : index;
  }

  function findVariant(size, color) {
    const sIndex = sizeKey();
    const cIndex = colorKey();
    return (product.variants || []).find(function (variant) {
      const options = variant.options || [variant.option1, variant.option2, variant.option3];
      const sizeOk = !size || options[sIndex] === size;
      const colorOk = !color || options[cIndex] === color;
      return sizeOk && colorOk;
    });
  }

  function selectedPack() {
    return (
      root.querySelector('[data-qc-pack].is-selected') ||
      root.querySelector('[data-qc-pack][data-qty="2"]') ||
      packs[0]
    );
  }

  function currentQty() {
    return Number(selectedPack().dataset.qty || '1');
  }

  function currentPrice() {
    return Number(selectedPack().dataset.price || '0');
  }

  function currentCompare() {
    return Number(selectedPack().dataset.compare || '0');
  }

  function updatePrices() {
    const price = formatMoney(currentPrice());
    const compare = formatMoney(currentCompare());
    priceEls.forEach(function (el) {
      el.textContent = price;
    });
    compareEls.forEach(function (el) {
      el.textContent = compare;
      el.hidden = currentCompare() <= currentPrice();
    });
  }

  const catalogGallery = root.querySelector('[data-qc-catalog]');
  const countEl = root.querySelector('[data-qc-catalog-count]');
  const titleEl = root.querySelector('[data-qc-catalog-title]');

  function setMainImage(src) {
    if (!src) return;
    const slide = slides.find(function (item) {
      return sameImage(item.dataset.src, src);
    });
    const resolved = (slide && slide.dataset.src) || src;
    if (mainImage) mainImage.src = resolved;
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', sameImage(thumb.dataset.src, resolved));
    });
    if (slide) {
      const index = slides.indexOf(slide);
      updateDots(index);
    }
    if (isMobile() && sliderTrack && slide) {
      sliderTrack.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
  }

  const slider = root.querySelector('[data-qc-slider]');
  const sliderTrack = slider && slider.querySelector('.qc-love__slider-track');
  const slides = Array.from(root.querySelectorAll('[data-qc-slide]'));
  const dotsWrap = root.querySelector('[data-qc-dots]');

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function imageFile(url) {
    if (!url) return '';
    return String(url)
      .split('?')[0]
      .split('/')
      .pop()
      .replace(/_\d+x\d*/g, '')
      .toLowerCase();
  }

  function sameImage(a, b) {
    if (!a || !b) return false;
    return a === b || imageFile(a) === imageFile(b);
  }

  function updateDots(index) {
    if (index < 0 || index >= slides.length) return;
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });
    if (countEl) {
      countEl.textContent = index + 1 + ' / ' + slides.length;
    }
    const title = slides[index] && slides[index].querySelector('.qc-love__slide-title');
    if (titleEl && title) titleEl.textContent = title.textContent;
    if (!dotsWrap) return;
    dotsWrap.querySelectorAll('.qc-love__dot').forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
    const src = slides[index] && slides[index].dataset.src;
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', sameImage(thumb.dataset.src, src));
    });
  }

  function scrollToSlide(src) {
    if (!isMobile() || !sliderTrack || !src) return;
    const slide = slides.find(function (item) {
      return sameImage(item.dataset.src, src);
    });
    if (slide) {
      sliderTrack.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
  }

  if (dotsWrap && slides.length && !catalogGallery) {
    slides.forEach(function (slide, index) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'qc-love__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Image ' + (index + 1));
      dot.addEventListener('click', function () {
        sliderTrack.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        if (mainImage) mainImage.src = slide.dataset.src;
      });
      dotsWrap.appendChild(dot);
    });
  }

  if (sliderTrack) {
    sliderTrack.addEventListener('scroll', function () {
      const index = Math.round(sliderTrack.scrollLeft / Math.max(sliderTrack.clientWidth, 1));
      updateDots(index);
      const slide = slides[index];
      if (slide && mainImage && !catalogGallery) mainImage.src = slide.dataset.src;
    });
  }

  function colorImage(color) {
    if (!color) return '';
    const raw = String(color).toLowerCase().replace(/ - .*/, '').trim();
    const aliases = {
      gray: ['gray', 'grey', 'gris'],
      grey: ['gray', 'grey', 'gris'],
      gris: ['gray', 'grey', 'gris'],
      navy: ['navy', 'navy blue', 'bleu', 'bleu marine'],
      'navy blue': ['navy', 'navy blue', 'bleu', 'bleu marine'],
      bleu: ['navy', 'navy blue', 'bleu', 'bleu marine'],
      'bleu marine': ['navy', 'navy blue', 'bleu', 'bleu marine'],
      burgundy: ['burgundy', 'burgandy', 'bordeaux'],
      burgandy: ['burgundy', 'burgandy', 'bordeaux'],
      bordeaux: ['burgundy', 'burgandy', 'bordeaux'],
      black: ['black', 'noir'],
      noir: ['black', 'noir'],
    };
    const keys = [raw].concat(aliases[raw] || []);
    for (let i = 0; i < keys.length; i += 1) {
      if (colorImages[keys[i]]) return colorImages[keys[i]];
    }
    const found = Object.keys(colorImages).find(function (key) {
      return key === raw || key.indexOf(raw) !== -1 || raw.indexOf(key) !== -1;
    });
    return found ? colorImages[found] : '';
  }

  function variantImage(variant) {
    if (!variant) return '';
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    const options = variant.options || [variant.option1, variant.option2, variant.option3];
    const color = options[colorKey()];
    return colorImage(color);
  }

  function firstItemVariant() {
    const pack = selectedPack();
    const size = pack.querySelector('[data-qc-size="0"]');
    const color = pack.querySelector('[data-qc-color="0"]');
    return findVariant(size && size.value, color && color.value);
  }

  const groupedSizes = root.dataset.qcGroupedSizes === 'true';

  function catalogProduct(id) {
    return catalogProducts.find(function (item) {
      return String(item.id) === String(id);
    });
  }

  function availableVariants(item) {
    return ((item && item.variants) || []).filter(function (variant) {
      return variant.available;
    });
  }

  function variantSizeCode(variant) {
    const raw = [variant && variant.option1, variant && variant.title]
      .filter(Boolean)
      .join(' / ')
      .toUpperCase();
    const parts = raw.split(/[\s\/\-]+/).filter(Boolean);
    const codes = ['XXL', 'XL', 'XS', 'S', 'M', 'L'];
    for (let i = 0; i < parts.length; i += 1) {
      if (codes.indexOf(parts[i]) !== -1) return parts[i];
    }
    return '';
  }

  function sizeGroupCodes(group) {
    return String(group) === '2' ? ['L', 'XL'] : ['S', 'M'];
  }

  function sizeGroupLabel(group) {
    return String(group) === '2' ? 'Taille 2 (L ou XL)' : 'Taille 1 (S ou M)';
  }

  function pickFromSizeGroup(item, group) {
    const codes = sizeGroupCodes(group);
    const prefer = String(group) === '2' ? ['L', 'XL'] : ['M', 'S'];
    const candidates = ((item && item.variants) || []).filter(function (variant) {
      return variant.available && codes.indexOf(variantSizeCode(variant)) !== -1;
    });
    if (!candidates.length) return null;
    candidates.sort(function (a, b) {
      return Number(b.inventory || 0) - Number(a.inventory || 0);
    });
    if (candidates.length === 1) return candidates[0];
    if (Number(candidates[0].inventory || 0) > Number(candidates[1].inventory || 0)) {
      return candidates[0];
    }
    for (let i = 0; i < prefer.length; i += 1) {
      const found = candidates.find(function (variant) {
        return variantSizeCode(variant) === prefer[i];
      });
      if (found) return found;
    }
    return candidates[0];
  }

  function groupForVariant(variant) {
    const code = variantSizeCode(variant);
    if (code === 'L' || code === 'XL') return '2';
    if (code === 'S' || code === 'M') return '1';
    return '';
  }

  function preferredGroup(item) {
    if (pickFromSizeGroup(item, '1')) return '1';
    if (pickFromSizeGroup(item, '2')) return '2';
    return '';
  }

  function preferredVariant(item) {
    if (groupedSizes) return pickFromSizeGroup(item, preferredGroup(item));
    const list = availableVariants(item);
    return (
      list.find(function (variant) {
        return variant.title === 'M' || /(^|\/ )M$/.test(variant.title);
      }) || list[0]
    );
  }

  function selectedRowVariant(row) {
    const productSelect = row && row.querySelector('[data-qc-product]');
    const variantSelect = row && row.querySelector('[data-qc-variant]');
    const item = catalogProduct(productSelect && productSelect.value);
    if (!item) return null;
    if (groupedSizes) {
      return pickFromSizeGroup(item, variantSelect && variantSelect.value) || preferredVariant(item);
    }
    return (
      availableVariants(item).find(function (variant) {
        return String(variant.id) === String(variantSelect && variantSelect.value);
      }) || preferredVariant(item)
    );
  }

  function fillGroupedSizeSelect(select, item, selectedId) {
    let selected = selectedId;
    if (selected !== '1' && selected !== '2') {
      const currentVariant = ((item && item.variants) || []).find(function (variant) {
        return String(variant.id) === String(selectedId);
      });
      selected = groupForVariant(currentVariant) || preferredGroup(item);
    }
    select.innerHTML = '';
    ['1', '2'].forEach(function (group) {
      if (!pickFromSizeGroup(item, group)) return;
      const option = document.createElement('option');
      option.value = group;
      option.textContent = sizeGroupLabel(group);
      if (group === selected) option.selected = true;
      select.appendChild(option);
    });
    if (select.value === '' && select.options.length) select.selectedIndex = 0;
  }

  function fillVariantSelect(select, item, selectedId) {
    if (!select || !item) return;
    if (groupedSizes) {
      fillGroupedSizeSelect(select, item, selectedId);
      return;
    }
    const list = availableVariants(item);
    const preferred = preferredVariant(item);
    const current = selectedId || (preferred && preferred.id);
    select.innerHTML = '';
    list.forEach(function (variant) {
      const option = document.createElement('option');
      option.value = String(variant.id);
      option.textContent = variant.title;
      if (String(variant.id) === String(current)) option.selected = true;
      select.appendChild(option);
    });
  }

  function updateCatalogRow(row) {
    if (!row) return;
    const item = catalogProduct(row.querySelector('[data-qc-product]') && row.querySelector('[data-qc-product]').value);
    const variantSelect = row.querySelector('[data-qc-variant]');
    const img = row.querySelector('[data-qc-item-image]');
    fillVariantSelect(variantSelect, item, variantSelect && variantSelect.value);
    const variant = selectedRowVariant(row);
    if (img) img.src = (variant && variant.image) || (item && item.image) || img.src;
  }

  function initCatalogPacks() {
    packs.forEach(function (pack) {
      const rows = Array.from(pack.querySelectorAll('[data-qc-item]'));
      rows.forEach(function (row, index) {
        const productSelect = row.querySelector('[data-qc-product]');
        const variantSelect = row.querySelector('[data-qc-variant]');
        const defaultItem = catalogProducts[Math.min(index, catalogProducts.length - 1)] || catalogProducts[0];
        if (productSelect && defaultItem) productSelect.value = String(defaultItem.id);
        fillVariantSelect(
          variantSelect,
          defaultItem,
          groupedSizes ? preferredGroup(defaultItem) : preferredVariant(defaultItem) && preferredVariant(defaultItem).id
        );
        updateCatalogRow(row);
        if (productSelect) {
          productSelect.addEventListener('change', function () {
            const item = catalogProduct(productSelect.value);
            fillVariantSelect(
              variantSelect,
              item,
              groupedSizes ? preferredGroup(item) : preferredVariant(item) && preferredVariant(item).id
            );
            updateCatalogRow(row);
          });
        }
        if (variantSelect) {
          variantSelect.addEventListener('change', function () {
            updateCatalogRow(row);
          });
        }
      });
    });
  }

  function updateItemImage(row) {
    if (!row) return;
    const img = row.querySelector('[data-qc-item-image]');
    const size = row.querySelector('[data-qc-size]');
    const color = row.querySelector('[data-qc-color]');
    const variant = findVariant(size && size.value, color && color.value);
    const src = variantImage(variant) || colorImage(color && color.value);
    if (img && src) img.src = src;
  }

  function selectPack(pack) {
    packs.forEach(function (item) {
      const on = item === pack;
      item.classList.toggle('is-selected', on);
      item.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    updatePrices();
    if (useCatalogPacks) {
      pack.querySelectorAll('[data-qc-item]').forEach(updateCatalogRow);
    } else {
      pack.querySelectorAll('.qc-love__variant').forEach(updateItemImage);
    }
    if (catalogGallery) return;
    const variant = firstItemVariant();
    setMainImage(variantImage(variant));
  }

  packs.forEach(function (pack) {
    pack.addEventListener('click', function (event) {
      if (event.target.closest('select')) return;
      selectPack(pack);
    });
    pack.addEventListener('keydown', function (event) {
      if (event.target.closest('select')) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        selectPack(pack);
      }
    });
    pack.querySelectorAll('select').forEach(function (select) {
      select.addEventListener('change', function () {
        if (useCatalogPacks) return;
        const row = select.closest('.qc-love__variant');
        updateItemImage(row);
        if (pack.classList.contains('is-selected') && row) {
          const size = row.querySelector('[data-qc-size]');
          const color = row.querySelector('[data-qc-color]');
          const variant = findVariant(size && size.value, color && color.value);
          if (!catalogGallery) {
            setMainImage(variantImage(variant) || colorImage(color && color.value));
          }
        }
      });
    });
    if (!useCatalogPacks) {
      pack.querySelectorAll('.qc-love__variant').forEach(updateItemImage);
    }
  });

  const startPack =
    root.querySelector('[data-qc-pack].is-selected') ||
    root.querySelector('[data-qc-pack][data-qty="2"]') ||
    packs[0];
  if (startPack) selectPack(startPack);
  if (useCatalogPacks) initCatalogPacks();

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
      });
      setMainImage(thumb.dataset.src);
    });
  });

  root.querySelectorAll('[data-qc-swatch]').forEach(function (swatch) {
    const name = (swatch.dataset.qcSwatch || '').toLowerCase();
    const color = colorMap[name] || colorMap[name.replace(/ - .*/, '')] || '#888';
    swatch.style.background = color;
    swatch.addEventListener('click', function () {
      const select = swatch.closest('.qc-love__field').querySelector('select');
      if (!select) return;
      select.value = swatch.dataset.qcSwatch;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      swatch.parentElement.querySelectorAll('[data-qc-swatch]').forEach(function (item) {
        item.classList.toggle('is-active', item === swatch);
      });
      const mapped = colorImage(swatch.dataset.qcSwatch);
      if (mapped && !catalogGallery) setMainImage(mapped);
    });
  });

  function tick() {
    const now = new Date();
    const end = new Date(now);
    end.setHours(23, 59, 59, 999);
    let diff = Math.max(0, end.getTime() - now.getTime());
    const hours = Math.floor(diff / 3600000);
    diff -= hours * 3600000;
    const minutes = Math.floor(diff / 60000);
    diff -= minutes * 60000;
    const seconds = Math.floor(diff / 1000);
    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
    if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  tick();
  setInterval(tick, 1000);
  updatePrices();

  function showError(message) {
    if (errorEl) errorEl.textContent = message || '';
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function isMoroccanPhone(phone) {
    return /^(?:\+?212|0)[5-8]\d{8}$/.test(String(phone || '').replace(/[\s.-]/g, ''));
  }

  function syncDeliveryPhone() {
    if (!form) return;
    const whatsapp = form.elements.whatsapp;
    const delivery = form.elements.telephone;
    const same = form.elements.tel_identique;
    if (!whatsapp || !delivery || !same) return;
    if (same.checked) {
      delivery.value = whatsapp.value;
      delivery.readOnly = true;
    } else {
      delivery.readOnly = false;
    }
  }

  if (form) {
    const whatsapp = form.elements.whatsapp;
    const same = form.elements.tel_identique;
    if (whatsapp) whatsapp.addEventListener('input', syncDeliveryPhone);
    if (same) same.addEventListener('change', syncDeliveryPhone);
    syncDeliveryPhone();
  }

  function normalizePhone(phone) {
    var value = String(phone || '').replace(/[\s.-]/g, '');
    if (value.indexOf('+212') === 0) value = '0' + value.slice(4);
    else if (value.indexOf('212') === 0 && value.length > 9) value = '0' + value.slice(3);
    return value.replace(/\D/g, '');
  }

  function findEasySellVm(name) {
    const rootVm = window.easysellApp;
    if (!rootVm) return null;
    const stack = [rootVm];
    while (stack.length) {
      const vm = stack.pop();
      const vmName = (vm.$options && (vm.$options.name || vm.$options._componentTag)) || '';
      if (vmName === name) return vm;
      (vm.$children || []).forEach(function (child) {
        stack.push(child);
      });
    }
    return null;
  }

  function fillVueInput(el, value) {
    if (!el) return;
    const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    setter.call(el, value);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function fillEasySellField(orderForm, key, value) {
    const lists = [orderForm.inputFields, orderForm.fields];
    if (orderForm.$store && orderForm.$store.state && orderForm.$store.state.form) {
      lists.push(orderForm.$store.state.form.fields);
    }
    lists.forEach(function (list) {
      if (!list) return;
      list.forEach(function (field) {
        if (field.value !== key) return;
        if (orderForm.$set) orderForm.$set(field, 'model', value);
        else field.model = value;
        field.hasError = false;
        if (typeof orderForm.onFieldChange === 'function') {
          try {
            orderForm.onFieldChange(field);
          } catch (e) {
            /* ignore */
          }
        }
      });
    });
    fillVueInput(document.getElementById('es-' + key), value);
  }

  function easySellHasOrder(orderForm) {
    const formState = orderForm && orderForm.$store && orderForm.$store.state && orderForm.$store.state.form;
    return Boolean(
      document.getElementById('es-thanks-modal') ||
        (formState && formState.order)
    );
  }

  async function waitForEasySellOrder(orderForm, timeoutMs) {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      if (easySellHasOrder(orderForm)) return true;
      await wait(200);
    }
    return easySellHasOrder(orderForm);
  }

  function easySellCart(orderForm) {
    return (
      orderForm &&
      orderForm.$store &&
      orderForm.$store.state &&
      orderForm.$store.state.cart &&
      orderForm.$store.state.cart.cart
    );
  }

  function easySellItemCount(cart) {
    if (!cart) return 0;
    const items = cart.items || [];
    if (items.length) {
      return items.reduce(function (sum, item) {
        return sum + Number(item.quantity || 1);
      }, 0);
    }
    return Number(cart.itemCount || cart.item_count || 0);
  }

  function applyPackPriceAndShipping(orderForm, packPriceCents, qty) {
    const store = orderForm.$store;
    if (!store || !store.state) return false;
    const packPrice = Math.round(Number(packPriceCents) / 100);
    const cart = store.state.cart && store.state.cart.cart;
    const count = easySellItemCount(cart);
    if (!cart || !cart.items || !cart.items.length || packPrice <= 0) return false;
    if (Number(qty) > 0 && count !== Number(qty)) return false;
    const current = Number(cart.totalPrice || 0);
    const items = cart.items;
    let remaining = packPrice;
    items.forEach(function (item, index) {
      const share =
        index === items.length - 1
          ? remaining
          : Math.round((packPrice * Number(item.quantity || 1)) / count);
      remaining -= share;
      item.line = share;
      item.linePrice = share;
      item.final_line_price = share;
      item.price = Math.round(share / Number(item.quantity || 1));
      item.final_price = item.price;
      item.discounted_price = item.price;
    });
    cart.totalPrice = packPrice;
    cart.original_total_price = current;
    cart.total_discount = Math.max(0, current - packPrice);

    const option =
      qty > 1
        ? {
            id: 'qc-love-free',
            name: 'Livraison gratuite',
            price: 0,
            hasCondition: false,
          }
        : {
            id: '5ufbp2',
            name: 'Livraison',
            price: 35,
            hasCondition: false,
            limitProducts: 'whitelist',
            limitProductsType: 'products',
            products: ['11014074794311'],
          };
    if (store.state.shipping) {
      store.state.shipping.options = [option];
      store.state.shipping.selectedOption = option;
    }
    return true;
  }

  async function refreshEasySellCart(orderForm, app) {
    const store = orderForm.$store;
    if (store && typeof store.dispatch === 'function') {
      try {
        await store.dispatch('cart/fetchCart');
      } catch (e) {
        /* ignore */
      }
      try {
        await store.dispatch('shipping/setShippingOptions');
      } catch (e) {
        /* ignore */
      }
    } else if (app && typeof app.fetchCart === 'function') {
      try {
        await Promise.resolve(app.fetchCart());
      } catch (e) {
        /* ignore */
      }
    }
    for (let i = 0; i < 20; i += 1) {
      const cart = easySellCart(orderForm);
      if (cart && cart.itemCount > 0) return true;
      await wait(150);
    }
    return Boolean(easySellCart(orderForm) && easySellCart(orderForm).itemCount > 0);
  }

  async function submitEasySellInBackground(customer) {
    const app = findEasySellVm('App') || window.easysellApp;
    const orderForm = findEasySellVm('OrderForm');
    if (!app || !orderForm || typeof orderForm.validateAndSubmit !== 'function') {
      return false;
    }

    document.body.classList.add('qc-es-silent');

    if (typeof app.enablePopupForm === 'function') {
      try {
        app.enablePopupForm();
      } catch (e) {
        /* ignore */
      }
    } else if (typeof app.onStickyButtonClick === 'function') {
      try {
        app.onStickyButtonClick();
      } catch (e) {
        /* ignore */
      }
    }

    await wait(300);
    await refreshEasySellCart(orderForm, app);
    if (!applyPackPriceAndShipping(orderForm, customer.packPrice, customer.qty)) {
      if (typeof orderForm.closeEasySellPopup === 'function') orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
      return false;
    }
    await wait(150);

    orderForm.selectedCountryCode = 'MA';
    if (orderForm.$store && orderForm.$store.state && orderForm.$store.state.form) {
      orderForm.$store.state.form.country = 'MA';
    }

    fillEasySellField(orderForm, 'first_name', customer.name);
    fillEasySellField(orderForm, 'phone', customer.phone);
    fillEasySellField(orderForm, 'address', customer.address);
    if (!applyPackPriceAndShipping(orderForm, customer.packPrice, customer.qty)) {
      if (typeof orderForm.closeEasySellPopup === 'function') orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
      return false;
    }
    await wait(150);

    if (typeof orderForm.validate === 'function' && !orderForm.validate()) {
      if (typeof orderForm.closeEasySellPopup === 'function') orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
      return false;
    }

    const accepted = orderForm.validateAndSubmit();
    if (!accepted) {
      if (typeof orderForm.closeEasySellPopup === 'function') orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
      return false;
    }

    const placed = await waitForEasySellOrder(orderForm, 20000);
    if (!placed && typeof orderForm.closeEasySellPopup === 'function') {
      orderForm.closeEasySellPopup();
      document.body.classList.remove('qc-es-silent');
    }
    return placed;
  }

  function packItemCount(items) {
    return items.reduce(function (sum, item) {
      return sum + Number(item.quantity || 1);
    }, 0);
  }

  function shopifyCartCount(cart) {
    if (!cart) return 0;
    if (typeof cart.item_count === 'number') return Number(cart.item_count);
    return (cart.items || []).reduce(function (sum, item) {
      return sum + Number(item.quantity || 1);
    }, 0);
  }

  async function fetchShopifyCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('cart fetch failed');
    return response.json();
  }

  async function addPackToCart(items) {
    const expected = packItemCount(items);
    async function clearAndAdd() {
      await fetch(cartClearUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items }),
      });
      if (!response.ok) throw new Error('cart add failed');
      await response.json();
    }
    await clearAndAdd();
    let cart = await fetchShopifyCart();
    if (shopifyCartCount(cart) !== expected) {
      await clearAndAdd();
      cart = await fetchShopifyCart();
    }
    if (shopifyCartCount(cart) !== expected) {
      throw new Error('cart qty mismatch');
    }
    return cart;
  }

  async function submitOrder(event) {
    event.preventDefault();
    if (orderSubmitting) return;
    orderSubmitting = true;

    showError('');

    const name = form.elements.nom.value.trim();
    const whatsapp = form.elements.whatsapp.value.trim();
    syncDeliveryPhone();
    const phone = form.elements.telephone.value.trim();
    const city = form.elements.ville.value.trim();
    const address = form.elements.adresse.value.trim();

    if (!name || !whatsapp || !phone || !city || !address) {
      orderSubmitting = false;
      showError('Merci de remplir nom, WhatsApp, téléphone livraison, ville et adresse.');
      return;
    }

    if (!isMoroccanPhone(whatsapp)) {
      orderSubmitting = false;
      showError('Entrez un WhatsApp marocain valide (06 / 07…).');
      return;
    }

    if (!isMoroccanPhone(phone)) {
      orderSubmitting = false;
      showError('Entrez un numéro de livraison marocain valide (06 / 07…).');
      return;
    }

    const qty = currentQty();
    const items = [];
    for (let i = 0; i < qty; i += 1) {
      const pack = selectedPack();
      if (useCatalogPacks) {
        const row = pack.querySelectorAll('[data-qc-item]')[i];
        const productSelect = row && row.querySelector('[data-qc-product]');
        const item = catalogProduct(productSelect && productSelect.value);
        const variant = selectedRowVariant(row);
        const sizeSelect = row && row.querySelector('[data-qc-variant]');
        if (!item || !variant) {
          orderSubmitting = false;
          showError('Choisis un produit et une taille pour chaque article.');
          return;
        }
        items.push({
          id: variant.id,
          quantity: 1,
          properties: {
            Pack: pack.dataset.name,
            Produit: item.title,
            Taille: groupedSizes
              ? sizeGroupLabel(sizeSelect && sizeSelect.value) + ' → ' + variant.title + ' (selon stock)'
              : variant.title,
            Paiement: 'COD',
            WhatsApp: whatsapp,
            'Téléphone livraison': phone,
          },
        });
      } else {
        const sizeSelect = pack.querySelector('[data-qc-size="' + i + '"]') || pack.querySelector('[data-qc-size="0"]');
        const colorSelect = pack.querySelector('[data-qc-color="' + i + '"]') || pack.querySelector('[data-qc-color="0"]');
        const variant = findVariant(sizeSelect && sizeSelect.value, colorSelect && colorSelect.value);
        if (!variant || variant.available === false) {
          orderSubmitting = false;
          showError('Cette taille / couleur n’est pas disponible.');
          return;
        }
        items.push({
          id: variant.id,
          quantity: 1,
          properties: {
            Pack: selectedPack().dataset.name,
            Paiement: 'COD',
            WhatsApp: whatsapp,
            'Téléphone livraison': phone,
          },
        });
      }
    }

    const original = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.textContent = 'جاري الإرسال…';
    }

    function unlock() {
      orderSubmitting = false;
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-busy');
        submitBtn.textContent = original;
      }
    }

    try {
      await addPackToCart(items);

      await fetch(cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          note:
            'COD Queen Closet Love — WhatsApp: ' +
            whatsapp +
            ' — Livraison: ' +
            phone,
          attributes: {
            Nom: name,
            WhatsApp: whatsapp,
            'Téléphone livraison': phone,
            Ville: city,
            Adresse: address,
            Paiement: 'Paiement à la livraison',
          },
        }),
      });

      const discount = selectedPack().dataset.discount;
      if (discount) {
        await fetch('/discount/' + encodeURIComponent(discount), { credentials: 'same-origin' });
      }

      const placed = await submitEasySellInBackground({
        name: name,
        phone: normalizePhone(whatsapp),
        address:
          address +
          ' — ' +
          city +
          ' | WhatsApp: ' +
          whatsapp +
          ' | Livraison: ' +
          phone,
        packPrice: currentPrice(),
        qty: qty,
      });

      document.body.classList.remove('qc-es-silent');
      if (!placed) {
        showError('Impossible d’envoyer la commande. Réessayez.');
        unlock();
        return;
      }
      if (submitBtn) {
        submitBtn.textContent = 'تم الإرسال';
        submitBtn.removeAttribute('aria-busy');
      }
    } catch (error) {
      document.body.classList.remove('qc-es-silent');
      showError('Impossible d’envoyer la commande. Réessayez.');
      unlock();
    }
  }

  form.addEventListener('submit', submitOrder);
  if (submitBtn) {
    submitBtn.addEventListener('click', function (event) {
      if (orderSubmitting) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  }

  function formIsComplete() {
    if (!form) return false;
    const name = (form.elements.nom && form.elements.nom.value.trim()) || '';
    const whatsapp = (form.elements.whatsapp && form.elements.whatsapp.value.trim()) || '';
    const phone = (form.elements.telephone && form.elements.telephone.value.trim()) || '';
    const city = (form.elements.ville && form.elements.ville.value.trim()) || '';
    const address = (form.elements.adresse && form.elements.adresse.value.trim()) || '';
    return Boolean(name && whatsapp && phone && city && address);
  }

  function isInView(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.72 && rect.bottom > 80;
  }

  function goToForm() {
    const field = root.querySelector('#LoveNom');
    const box = root.querySelector('.qc-love__cod');
    const target = box || field;
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (field) {
      window.setTimeout(function () {
        field.focus({ preventScroll: true });
      }, 450);
    }
  }

  function goToBundle() {
    const bundle = root.querySelector('#qc-love-bundle') || root.querySelector('[data-qc-bundle]');
    const packs = root.querySelector('[data-qc-bundle]');
    if (bundle) {
      bundle.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (packs) {
      packs.classList.add('is-target');
      window.setTimeout(function () {
        packs.classList.remove('is-target');
      }, 1300);
    }
  }

  root.querySelectorAll('[data-qc-scroll-order]').forEach(function (button) {
    button.addEventListener('click', function () {
      const packs = root.querySelector('[data-qc-bundle]');
      if (!isInView(packs)) {
        goToBundle();
        return;
      }
      if (!formIsComplete()) {
        goToForm();
        return;
      }
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  });

  root.querySelectorAll('[data-qc-scroll-product]').forEach(function (button) {
    button.addEventListener('click', function () {
      const photos = root.querySelector('#qc-love-photos') || root.querySelector('.qc-love__product');
      if (photos) photos.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
